__turbopack_context__.v({
  "freeBox": "PlasmicLabel-module__Ps8Aqq__freeBox",
  "root": "PlasmicLabel-module__Ps8Aqq__root",
  "slotTargetChildrensize_lg": "PlasmicLabel-module__Ps8Aqq__slotTargetChildrensize_lg",
  "slotTargetChildrensize_sm": "PlasmicLabel-module__Ps8Aqq__slotTargetChildrensize_sm",
  "text": "PlasmicLabel-module__Ps8Aqq__text",
  "textrequirementIndicator_optional": "PlasmicLabel-module__Ps8Aqq__textrequirementIndicator_optional",
  "textrequirementIndicator_required": "PlasmicLabel-module__Ps8Aqq__textrequirementIndicator_required",
});
